import { render, staticRenderFns } from "./AddTaskForm.vue?vue&type=template&id=b7a9afe4&"
import script from "./AddTaskForm.vue?vue&type=script&lang=js&"
export * from "./AddTaskForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports